import { TableCell } from '@ksyos/design-system';
import { useTheme } from 'styled-components';
import { OutclinicDashboardStatus } from '@common/enums/outclinicDashboard/outclinicDashboardStatus';
import { getSelectedLanguage } from '@frontend/translate';
import { OutclinicDashboardTableStatusIcon } from './OutclinicDashboardTableStatusIcon';
import { OutclinicDashboardTableTextBox } from './OutclinicDashboardTableTextBox';

interface IOutclinicDashboardTableCellProps {
    label?: string;
    status?: OutclinicDashboardStatus;
}

export function OutclinicDashboardTableCell(props: IOutclinicDashboardTableCellProps) {
    const { label, status } = props;
    const theme = useTheme();

    const cellStyles = {
        height: theme.space[14],
        padding: `0px ${theme.space[4]}`,
    };

    switch (status) {
        case OutclinicDashboardStatus.checked:
            return (
                <TableCell sx={cellStyles}>
                    <OutclinicDashboardTableStatusIcon
                        label={label}
                        status={status}
                    />
                </TableCell>
            );

        case OutclinicDashboardStatus.notApplicable:
            return (
                <TableCell sx={cellStyles}>
                    <OutclinicDashboardTableTextBox
                        color="disabled"
                        label={getSelectedLanguage().outclinicDashboard.notApplicable}
                    />
                </TableCell>
            );

        case OutclinicDashboardStatus.toDo:
            if (!label) {
                throw new Error('Label is required for status "toDo"');
            }

            return (
                <TableCell sx={cellStyles}>
                    <OutclinicDashboardTableTextBox
                        label={
                            getSelectedLanguage().outclinicDashboard[
                                label as keyof ReturnType<typeof getSelectedLanguage>['outclinicDashboard']
                            ]
                        }
                    />
                </TableCell>
            );

        case OutclinicDashboardStatus.warning:
            return (
                <TableCell sx={cellStyles}>
                    <OutclinicDashboardTableStatusIcon
                        label={label}
                        status={status}
                    />
                </TableCell>
            );

        default:
            return <TableCell sx={{ ...cellStyles, backgroundColor: theme.colors.neutral50 }}></TableCell>;
    }
}
